<template>
  <div class="ui basic news segment">
    <loading-indicator v-if="loading"/>
      
    <h2 class="ui header" v-if="news.length > 0">
      <img src="/images/logo.png" class="ui image"/>
      Neuerungen
    </h2>
    
    <div class="ui feed" v-if="news.length > 0">    
      <news-item v-for="item in news" :key="item.id" :item="item"/>
    </div>
  </div>
</template>


<script>
import listMixin from '../mixins/list'
import LoadingIndicator from '~shared/components/loading-indicator.vue'
import NewsItem from './news.vue'


export default {
  mixins: [listMixin],
  components: {
    LoadingIndicator,
    NewsItem
  }
}
</script>

<style>
.ui.basic.news.segment{
  margin-top: 4em;
}
</style>



// WEBPACK FOOTER //
// list.vue?3800f5a0